export default {
  loading: false,
  pb_loading: false,
  error: false,
  items: [],
  projects: [],
  bots: [],
  advanced: {},
  playbooks: [],
  accounts: [],
  proxies:[],
  proxies_tags:[],
  languages: [],
  pools: [],
  playbookAdvanced: {},
  playbooksEdits:{
    result: {}
  },
  view:{
    advanced: false,
    count: false,
    model: {},
    isNew: false
  },
  pagination: {
    limit: 10,
    page: 0,
    total: 0
  },
  stats: {
    byDate:{
      
    },
    byErrors:{
      
    },
    botReport:[]
  }
}
